import React, { Component } from "react"
import Leaderboard from "./Leaderboard"
import axios from "axios"
import "../config"

class Registration extends Component {
  render() {
    return (
      <section className="jumbotron">
        <div className="row align-items-center">
          <div className="col-md-8">
            <div className="py-3 text-center">
              <h2 className="mb-3">Welcome to Quizmaster 3000</h2>
              <p className="lead">Do you have what it takes?</p>
              <div id="invalid-fetch" className="invalid-feedback">
                There was a problem fetching the data. Please check your network
                connection.
              </div>
            </div>

            <div className="row">
              <div className="col-md-4 mb-3">
                <label htmlFor="username">Name</label>
                <input
                  type="text"
                  name="username"
                  id="username"
                  placeholder="Enter your name"
                  className="form-control"
                  autoComplete="off"
                  onKeyUp={this.key_up}
                />
                <div id="invalid-name" className="invalid-feedback">
                  That username is too short or already exists.
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor="difficulty">Difficulty</label>
                <select
                  className="custom-select d-block w-100"
                  id="difficulty"
                  required=""
                >
                  <option value="easy">Easy</option>
                  <option value="medium">Medium</option>
                  <option value="hard">Hard</option>
                </select>
              </div>
              <div className="col-md-4 mb-3">
                <label htmlFor="numQuestions">Number of Questions</label>
                <select
                  className="custom-select d-block w-100"
                  id="numQuestions"
                  required=""
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                </select>
              </div>
              <div className="col-md-12 mb-3">
                <label></label>
                <button
                  id="registerButton"
                  className="btn btn-primary btn-lg btn-block"
                  onClick={this.register}
                >
                  Play
                </button>
              </div>
            </div>
          </div>
          <div className="col">
            <Leaderboard {...this.props.leaderboard} />
          </div>
        </div>
      </section>
    )
  }

  // Function to check user registration and start game
  register = () => {
    // Basic username checking
    let username = document.getElementById("username").value
    if (username.length < 3 || username.length > 18) {
      document.getElementById("invalid-name").style.display = "block"
      return
    }

    let difficulty = document.getElementById("difficulty").value
    let numQuestions = document.getElementById("numQuestions").value

    // Axios call to post the new user to the database & fetch the question set from the API
    axios
      .post(global.config.base + "add", {
        username: username,
        difficulty: difficulty,
        numQuestions: numQuestions,
      })
      .then((res) => {
        var mul = difficulty === "hard" ? 3 : difficulty === "medium" ? 2 : 1

        this.fetchQuestions(difficulty, numQuestions)
          .then((questions) => {
            this.props.handleStateChange({
              game: {
                ...this.props.game,
                questions: questions,
                difficulty: difficulty,
                multiplier: mul,
                numQuestions: parseInt(numQuestions, 10),
                loading: false,
              },
              user: {
                ...this.props.user,
                id: res.data._id,
                name: res.data.username,
                registered: true,
              },
            })
          })
          .catch((err) => {
            console.log(err)
            document.getElementById("invalid-fetch").style.display = "block"
          })
      })
      .catch((err) => {
        console.log(err)
        document.getElementById("invalid-fetch").style.display = "block"
      })
  }

  // Async function to fetch questions from the API
  async fetchQuestions(difficulty, numQuestions) {
    var url =
      "https://opentdb.com/api.php?type=multiple&amount=" +
      numQuestions +
      "&difficulty=" +
      difficulty
    try {
      const res = await fetch(url)
      const data = await res.json()
      // Here we push all the answers together, mix them up and keep track of the correct value
      data.results.forEach((element) => {
        var allAnswers = []
        var correct = element.correct_answer
        var arr = Object.values(element.incorrect_answers)
        arr.push(correct)
        arr = this.shuffle(arr)

        arr.forEach((item) => {
          var q = {}
          q.answer = item
          q.correct = item === correct
          allAnswers.push(q)
        })
        element.allAnswers = allAnswers
      })
      return data.results
    } catch (error) {
      throw error
    }
  }

  // Function to shuffle the order of the answers in the array
  shuffle = (array) => {
    var currentIndex = array.length,
      randomIndex

    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex)
      currentIndex--
      ;[array[currentIndex], array[randomIndex]] = [
        array[randomIndex],
        array[currentIndex],
      ]
    }

    return array
  }

  // Function to allow enter press on username field when registering
  key_up = (e) => {
    var enterKey = 13 //Key Code for Enter Key
    if (e.which === enterKey) this.register()
  }
}

export default Registration
